// Hook para verificación del CAPTCHA

import { useCallback } from 'react';
import { verifyReCaptcha } from '../../componentes/action/captcha/verifyReCaptcha';

export const useCaptchaVerification = (setMessage, dispatch) => {
  const verifyCaptcha = useCallback(async (captchaToken, action, resetCaptcha) => {
    if (!captchaToken) {
      setMessage("Por favor, completa la verificación del CAPTCHA.");
      return false;
    }

    try {
      await verifyReCaptcha(captchaToken, setMessage, action, dispatch, resetCaptcha);
      return true;
    } catch (error) {
      setMessage("Error durante la verificación: " + error.message);
      return false;
    }
  }, [setMessage, dispatch]);

  return { verifyCaptcha };
};